/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Out_Reason_For_SortingInputs */

const vi_pl_out_reason_for_sorting = /** @type {(inputs: Pl_Out_Reason_For_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đưa đi phân loại`)
};

/**

* @param {Pl_Out_Reason_For_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_out_reason_for_sorting = /** @type {((inputs?: Pl_Out_Reason_For_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Out_Reason_For_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_out_reason_for_sorting(inputs)
});